import { ref, computed } from 'vue';

const isSelectionMode = ref(false);
const selectedMessageIds = ref(new Set());

export function useMessageSelection() {
  const startSelectionMode = () => {
    isSelectionMode.value = true;
    selectedMessageIds.value = new Set();
  };

  const exitSelectionMode = () => {
    isSelectionMode.value = false;
    selectedMessageIds.value.clear();
  };

  const toggleMessageSelection = messageId => {
    const newSet = new Set(selectedMessageIds.value);
    if (newSet.has(messageId)) {
      newSet.delete(messageId);
    } else {
      newSet.add(messageId);
    }
    selectedMessageIds.value = newSet;
  };

  const isMessageSelected = messageId => {
    return selectedMessageIds.value.has(messageId);
  };

  const selectedCount = computed(() => selectedMessageIds.value.size);

  const getSelectedMessageIds = () => {
    return Array.from(selectedMessageIds.value);
  };

  const clearSelection = () => {
    selectedMessageIds.value.clear();
  };

  return {
    isSelectionMode,
    selectedMessageIds,
    selectedCount,
    startSelectionMode,
    exitSelectionMode,
    toggleMessageSelection,
    isMessageSelected,
    getSelectedMessageIds,
    clearSelection,
  };
}
